export const usersListMockup = [
    {
      id: 1,
      firstName: "Andrei",
      lastName: "Pata",
      imagePath:
        "https://www.history.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTU3ODc4NjAyNDM5NDY4MzYx/lincoln-gettyimages-171127241.jpg",
      isSelected: false,
    },
    {
      id: 2,
      firstName: "Vlad",
      lastName: "Pata",
      imagePath:
        "https://www.history.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTU3ODc4NjAyNDM5NDY4MzYx/lincoln-gettyimages-171127241.jpg",
      isSelected: false,
    },
    {
      id: 3,
      firstName: "Cosmin",
      lastName: "Pata",
      imagePath:
        "https://www.history.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTU3ODc4NjAyNDM5NDY4MzYx/lincoln-gettyimages-171127241.jpg",
      isSelected: false,
    },
    {
      id: 4,
      firstName: "Vali",
      lastName: "Pata",
      imagePath:
        "https://www.history.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTU3ODc4NjAyNDM5NDY4MzYx/lincoln-gettyimages-171127241.jpg",
      isSelected: false,
    },
    {
      id: 5,
      firstName: "Ion",
      lastName: "Pata",
      imagePath:
        "https://www.history.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTU3ODc4NjAyNDM5NDY4MzYx/lincoln-gettyimages-171127241.jpg",
      isSelected: false,
    },
    {
      id: 6,
      firstName: "Mircea",
      lastName: "Pata",
      imagePath:
        "https://www.history.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTU3ODc4NjAyNDM5NDY4MzYx/lincoln-gettyimages-171127241.jpg",
      isSelected: false,
    },
  ];